import {TopNavBarButtonComponent, TopNavBarButtonProps} from 'module/TopNavBar/component/TopNavBarButton/TopNavBarButtonComponent';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import React from 'react';

export const KostPanelButton = React.memo((props: TopNavBarButtonProps) => (
	<TopNavBarButtonComponent variant={'outlined'}{...props}>
		<LocalShippingIcon fontSize={'small'}/>
		{props.btnDef?.label}
	</TopNavBarButtonComponent>
));